import makeStyles from "@mui/styles/makeStyles";
import { getBrandCustom } from "../../utils/getCustomColor";
import { colors } from "@zapalacorp/tokens";

const styles = makeStyles(() => ({
  textButton: {
    fontFamily: "Inter",
    fontSize: "12px",
    fontWeight: 700,
    lineHeight: "15px",
    color: colors.white,
    fontStyle: "normal",
  },
  badgeFilter: {
    width: "18px",
    height: "18px",
    backgroundColor: colors.white,
    fontFamily: "Poppins",
    fontSize: "12px !important",
    fontWeight: 700,
    lineHeight: "18px",
    borderRadius: "20px",
    color: getBrandCustom("primaryColor", colors.brandBlue600),
    paddingRight: "1px",
  },
  menu: {
    backgroundColor: colors.white,
    borderRadius: "12px",
    border: "1px solid #DEDEDE",
    width: "300px",
    marginTop: "45px",
    maxHeight: "50vh",
  },
  menuHeader: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    padding: "16px 16px 0 16px",
  },
  textHeader: {
    fontFamily: "Manrope",
    fontSize: "18px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "28px",
    color: "#344054",
  },
  list: {
    paddingBottom: "16px",
  },
}));

export default styles;
